import './styles.css';

import React from 'react';
import { Modal } from '@vtblife/uikit';

import classname from '@search/classname/src';
import { useStaticPathConfig } from '@search/common-core/src/StaticPathContext';

import Image from '../Image';
import SuccessModalImage from './SuccessModalImage.url.svg';

type Props = {
    title?: string;
    mobileDescription: React.ReactNode;
    desktopDescription: React.ReactNode;
    isMobile?: boolean;
} & ({
    onlyBody: true;
    onClose?: () => void;
} | {
    onlyBody?: false;
    onClose: () => void;
})

const cn = classname.bind(null, 'SuccessModal');

export const SuccessModal = ({
    onClose,
    title,
    mobileDescription,
    desktopDescription,
    onlyBody,
    isMobile
}: Props) => {
    const staticPath = useStaticPathConfig();

    const modalBody = (<>
        {isMobile && title && (
            <Modal.Title>{title}</Modal.Title>
        )}
        {isMobile ? (
            <p>{mobileDescription}</p>
        ) : (
            <div className={cn('content')}>
                <Image
                    url={`${staticPath}${SuccessModalImage}`}
                    className={cn('img')}
                    alt='success image'
                />
                <p className={cn('description')}>
                    {desktopDescription}
                </p>
            </div>
        )}
    </>);

    if (onlyBody) {
        return modalBody;
    }

    return (
        <Modal size='s' opened onClose={onClose}>
            {modalBody}
        </Modal>
    );
};
